export const supportsSelectedGameContent = (serverVersion?: string): boolean => {
    if (!serverVersion) return false;

    const version = serverVersion.match(/^(\d+)\.(\d+)(?:\.|$)/);
    if (!version) return false;

    const major = Number(version[1]);
    const minor = Number(version[2]);
    return major > 2 || (major === 2 && minor >= 11);
};

export const getSelectedGameIds = (gameGroups: any[] = []): any[] => {
    const selectedGameIds = (gameGroups || []).reduce((gameIds, group) => {
        if (!group || !Array.isArray(group.game_instances)) {
            return gameIds;
        }

        return gameIds.concat(group.game_instances);
    }, []);

    return selectedGameIds.filter(
        (gameId, index) => selectedGameIds.indexOf(gameId) === index
    );
};

export const filterItemsBySelectedGames = (
    items: any[] = [],
    selectedGroupType: string,
    gameGroups: any[] = [],
    getGameId: (item: any) => any
): any[] => {
    if (selectedGroupType !== "game") {
        return items;
    }

    const selectedGameIds = getSelectedGameIds(gameGroups).map(String);

    return items.filter(item =>
        selectedGameIds.includes(String(getGameId(item)))
    );
};

export const filterBundlesBySelectedGames = (
    bundles: any[],
    selectedGroupType: string,
    gameGroups: any[],
    gameSettings: any[]
): any[] => {
    const selectedBundleIds = (gameGroups || []).reduce(
        (ids, group) => ids.concat((group && group.game_bundles) || []),
        []
    ).map(String);
    const gameIds = gameSettings.map(game => String(game.id));

    return bundles
        .filter(bundle =>
            selectedGroupType !== "game" ||
            selectedBundleIds.includes(String(bundle.id))
        )
        .map(bundle => ({
            ...bundle,
            games: bundle.games.filter(game => gameIds.includes(String(game.id)))
        }))
        .filter(bundle => bundle.games.length > 0);
};

export const hasUnselectedGameContent = (
    settings,
    selectedGroupType: string,
    gameGroups: any[],
    serverVersion?: string
): boolean => {
    if (!supportsSelectedGameContent(serverVersion) || selectedGroupType !== "game") {
        return false;
    }

    const games = settings.game_settings || [];
    const bundles = settings.game_bundles || [];
    const selectedGames = filterItemsBySelectedGames(
        games, selectedGroupType, gameGroups, game => game.id
    );
    const selectedBundles = filterBundlesBySelectedGames(
        bundles, selectedGroupType, gameGroups, selectedGames
    );

    return selectedGames.length !== games.length ||
        selectedBundles.length !== bundles.length ||
        selectedBundles.some((bundle, index) =>
            bundle.games.length !== bundles[index].games.length
        );
};
